// Will be replaced during production builds - see prepare.sh
export const BuildVersion = "e17bc2f";
